import { ROUTE_PATH_PRIVACY_POLICY, ROUTE_PATH_TERMS_CONDITIONS } from '../../constants';
import { ActivatePageTranslations } from '../types';

export const translations: ActivatePageTranslations = {
  docTitle: 'Activer',
  beforeUnloadPrompt: 'Souhaitez-vous quitter cette page? Les changements apportés ne seront peut-être pas sauvegardés.',
  howWeSecureInfoLink: {
    href: '#',
    children: 'Comment sécurisons-nous vos renseignements?'
  },
  ineligibleModalTitle: `Vous n'êtes pas éligible pour vous inscrire à EnGarde`,
  steps: {
    personalInfo: {
      title: 'Renseignements personnels',
      leadText: [
        '<p>Félicitations! Vous êtes admissible au service EnGarde alimenté par Assist Identité, un avantage offert dans le cadre',
        'de votre programme de services bancaires BMO.</p>',
        '<p>EnGarde recueille ces renseignements dans le but de compléter votre abonnement et',
        'afin de vous fournir les services appropriés.</p>'
      ].join('\n'),
      footnote: [
      ].join('\n'),
      form: {
        field: {
          firstName: {
            label: 'Nom',
            'aria-label': 'Prénom',
            placeHolder: 'Prénom',
            error: {
              required: 'Veuillez indiquer votre prénom.',
              tooShort: [
                'Le prénom doit comporter entre 2 et 30 caractères et peut contenir des lettres,',
                `un seul trait d'union (-) et un seul espace à la fois.`
              ].join('\n'),
              tooLong: [
                'Le prénom doit comporter entre 2 et 30 caractères et peut contenir des lettres,',
                `un seul trait d'union (-) et un seul espace à la fois.`
              ].join('\n'),
              patternMismatch: [
                'Le prénom doit comporter entre 2 et 30 caractères et peut contenir des lettres,',
                `un seul trait d'union (-) et un seul espace à la fois.`
              ].join('\n')
            }
          },
          lastName: {
            label: 'Nom de famille',
            placeHolder: 'Nom de famille',
            error: {
              required: 'Veuillez indiquer votre nom de famille.',
              tooShort: [
                'Le nom de famille doit comporter entre 2 et 30 caractères et peut contenir des lettres,',
                `un seul trait d'union (-) et un seul espace à la fois.`
              ].join('\n'),
              tooLong: [
                'Le nom de famille doit comporter entre 2 et 30 caractères et peut contenir des lettres,',
                `un seul trait d'union (-) et un seul espace à la fois.`
              ].join('\n'),
              patternMismatch: [
                'Le nom de famille doit comporter entre 2 et 30 caractères et peut contenir des lettres,',
                `un seul trait d'union (-) et un seul espace à la fois.`
              ].join('\n')
            }
          },
          birthDate: {
            label: 'Année de naissance',
            'aria-label': 'Pourquoi dois-je fournir ma date de naissance?',
            helpText: [
              'Nous avons besoin de votre date de naissance pour configurer votre ',
              `service de surveillance de crédit et confirmer que vous avez au moins 18 ans.`
            ].join('\n'),
            error: {
              required: 'Veuillez saisir votre date de naissance.',
              badInput: 'Veuillez saisir une date de naissance valide (ex. AAAA/MM/JJ).',
              ineligible: [
                `Vous ne pouvez vous inscrire à EnGarde parce que vous n'avez pas atteint l'âge`,
                'de la majorité dans votre province ou territoire. Veuillez communiquer avec nous',
                `au 1 866 327 3078 si vous avez besoin d'aide supplémentaire.`
              ].join('\n'),
              apiError: [
                'Vous devez avoir au moins 18 ans pour pouvoir vous inscrire.'
              ].join(' ')
            }
          },
          dobMonth: {
            label: '',
            'aria-label': 'Mois',
            placeHolder: 'Mois'
          },
          dobDay: {
            label: 'Jour',
            placeHolder: 'Jour'
          },
          dobYear: {
            label: 'Année',
            placeHolder: 'Année'
          },
          phoneNumber: {
            label: 'Numéro de téléphone',
            placeHolder: 'p. ex., 5145551234',
            error: {
              required: 'Veuillez saisir votre numéro de téléphone.',
              tooShort: 'Veuillez saisir un numéro de téléphone valide (p. ex., 5145551234).',
              tooLong: 'Veuillez saisir un numéro de téléphone valide (p. ex., 5145551234).',
              patternMismatch: 'Veuillez saisir un numéro de téléphone valide (p. ex., 5145551234).',
              apiError: [
                'Il semble que vous avez déjà inscrit un compte avec cette nom et numéro de téléphone.',
                'Veuillez utiliser une autre nom et numéro de téléphone pour vous inscrire.'
              ].join(' ')
            }
          },
          emailAddress: {
            label: 'Adresse courriel',
            'aria-label': 'Adresse courriel',
            placeHolder: 'julietremblay@exemple.com',
            helpText: [
              'Votre identifiant sera votre adresse courriel. Veuillez utiliser une adresse',
              'courriel personnelle qui vous appartient et dont vous vous souviendrez facilement.'
            ].join('\n'),
            error: {
              required: 'Veuillez saisir votre adresse courriel.',
              tooShort: 'Veuillez saisir une adresse courriel valide (p. ex., julietremblay@exemple.com).',
              tooLong: 'Veuillez saisir une adresse courriel valide (p. ex., julietremblay@exemple.com).',
              patternMismatch: 'Veuillez saisir une adresse courriel valide (p. ex., julietremblay@exemple.com).',
              activated: [
                'Désolé, selon les renseignements fournis, vous avez déjà activé votre abonnement à',
                'EnGarde ou cette adresse courriel est déjà associée à un autre abonnement.'
              ].join('\n'),
              ineligible: [
                `Désolé, selon l'information fournie, vous n'êtes pas admissible à recevoir la`,
                'protection EnGarde avec votre forfait bancaire. Veuillez communiquer avec nous',
                `au 1 866 327-3078 pour obtenir de l'aide.`
              ].join('\n'),
              apiError: [
                'Il semble que vous avez déjà inscrit un compte avec cette adresse de courriel.',
                'Veuillez utiliser une autre adresse de courriel pour vous inscrire.'
              ].join(' ')
            }
          },
          marketingOptIn: {
            label: ''
          }
        },
        action: {
          cancel: {
            label: 'Annuler'
          },
          submit: {
            label: 'Continuer'
          }
        }
      }
    },
    contactInfo: {
      title: 'Adresse',
      leadText: [
        '<p>Félicitations! Vous êtes admissible au service EnGarde alimenté par Assist Identité,',
        ' un avantage offert dans le cadre de votre programme de services bancaires BMO.</p>',
        '<p>EnGarde recueille ces renseignements dans le but de compléter votre abonnement',
        'et afin de vous fournir les services appropriés.</p>'
      ].join('\n'),
      form: {
        field: {
          addressLine1: {
            label: 'Adresse',
            'aria-label': 'Adresse',
            placeHolder: 'Adresse',
            error: {
              required: 'Veuillez saisir votre adresse.',
              tooShort: [
                `L’adresse doit comporter entre 3 et 50 caractères et peut contenir des`,
                `lettres, des chiffres, un point (.), une apostrophe ('), une virgule (,) ainsi qu’un seul`,
                `trait d’union (-) et un seul espace à la fois.`
              ].join('\n'),
              tooLong: [
                `L’adresse doit comporter entre 3 et 50 caractères et peut contenir des`,
                `lettres, des chiffres, un point (.), une apostrophe ('), une virgule (,) ainsi qu’un seul`,
                `trait d’union (-) et un seul espace à la fois.`
              ].join('\n'),
              patternMismatch: [
                `L’adresse doit comporter entre 3 et 50 caractères et peut contenir des`,
                `lettres, des chiffres, un point (.), une apostrophe ('), une virgule (,) ainsi qu’un seul`,
                `trait d’union (-) et un seul espace à la fois.`
              ].join('\n')
            }
          },
          addressLine2: {
            label: 'Appartement, bureau, etc.',
            placeHolder: 'App., bureau, etc.',
            error: {
              tooLong: [
                `L’adresse doit comporter entre 3 et 50 caractères et peut contenir des`,
                `lettres, des chiffres, un point (.), une apostrophe ('), une virgule (,) ainsi qu’un seul`,
                `trait d’union (-) et un seul espace à la fois.`
              ].join('\n'),
              patternMismatch: [
                `L’adresse doit comporter entre 3 et 50 caractères et peut contenir des`,
                `lettres, des chiffres, un point (.), une apostrophe ('), une virgule (,) ainsi qu’un seul`,
                `trait d’union (-) et un seul espace à la fois.`
              ].join('\n')
            }
          },
          cityName: {
            label: 'Ville',
            placeHolder: 'Ville',
            error: {
              required: 'Veuillez saisir votre ville.',
              tooShort: [
                'La ville doit comporter entre 2 et 50 caractères et peut contenir des lettres ainsi qu’un',
                'seul trait d’union (-), une seule espace à la fois, un point (.) et une apostrophe (\').'
              ].join('\n'),
              tooLong: [
                'La ville doit comporter entre 2 et 50 caractères et peut contenir des lettres ainsi qu’un',
                'seul trait d’union (-), une seule espace à la fois, un point (.) et une apostrophe (\').'
              ].join('\n'),
              patternMismatch: [
                'La ville doit comporter entre 2 et 50 caractères et peut contenir des lettres ainsi qu’un',
                'seul trait d’union (-), une seule espace à la fois, un point (.) et une apostrophe (\').'
              ].join('\n')
            }
          },
          provinceCode: {
            label: 'Province',
            placeHolder: 'Province',
            error: {
              required: 'Veuillez sélectionner votre province.'
            }
          },
          postalCode: {
            label: 'Code postal',
            placeHolder: 'XNXNXN',
            error: {
              required: 'Veuillez saisir votre code postal.',
              tooShort: 'Veuillez saisir un code postal valide (p. ex. M1M 1M1).',
              tooLong: 'Veuillez saisir un code postal valide (p. ex. M1M 1M1).',
              patternMismatch: 'Veuillez saisir un code postal valide (p. ex. M1M 1M1).'
            }
          },
          acceptTermsConditions: {
            label: [
              'En cliquant sur Envoyer, je reconnais avoir lu et accepté les',
              `<a tabindex="0" data-router-link target="_blank" href=${ROUTE_PATH_TERMS_CONDITIONS}>conditions d&#39;utilisation</a> et`,
              `la <a tabindex="0" data-router-link target="_blank" href=${ROUTE_PATH_PRIVACY_POLICY}>politique de confidentialité</a>`,
              'qui s&#39;appliquent aux services fournis par EnGarde alimenté par Assist Identité, et j&#39;autorise le partage des renseignements',
              'sur mon crédit à Sigma Loyalty Group inc., le fournisseur d&#39;EnGarde, dans le but de confirmer mon identité et',
              'pour que la surveillance de mon dossier de crédit puisse commencer.'
            ].join(' '),
            error: {
              required: `Cochez cette case pour accepter les conditions d'utilisation.`
            }
          },
          recaptcha: {
            label: '',
            error: {
              required: 'Veuillez répondre au test CAPTCHA.'
            }
          }
        },
        action: {
          previous: {
            label: 'Précédent'
          },
          submit: {
            label: 'Envoyer'
          }
        }
      }
    },
    confirmation: {
      progressBadgeTitle: 'Confirmation',
      title: 'Vos services de protection de l’identité sont en vigueur!',
      leadText: [
        '<p>Merci de vous être inscrit pour profiter de votre abonnement gratuit à EnGarde!</p>',
        '<p>L’information que vous avez fournie lors de votre inscription sera automatiquement surveillée',
        'en ligne et par l’agence d’évaluation du crédit. Optimisez la protection de votre identité en',
        'configurant dès aujourd’hui votre compte en ligne, où vous pourrez saisir encore plus d’informations',
        'à des fins de surveillance de l’identité en ligne et consulter vos alertes.</p>',
        '<p>Veuillez consulter vos courriels pour obtenir un lien d’Assist Identité afin de configurer votre compte',
        'en ligne et d’accéder à vos services de protection d’identité.</p>'
      ].join('\n'),
      footnote: '',
      form: {
        field: {
          eToken: {
            label: ''
          }
        },
        action: {
          setupAccount: {
            label: 'Configurer le compte Identity Guard'
          }
        }
      }
    },
    partialConfirmation: {
      title: 'Un problème est survenu lors de la configuration de votre compte...',
      leadText: [
        '<p>Merci de vous être inscrit afin de bénéficier de votre abonnement gratuit à EnGarde!</p>',
        '<p>Nous avons bien reçu votre information, mais nous éprouvons des difficultés et ne pouvons',
        'traiter votre demande. D&#39;ici les 24 prochaines heures, vous recevrez un courriel dans lequel',
        'seront indiquées les étapes à suivre pour configurer vos services',
        'de protection de l&#39;identité.</p>'
      ].join('\n')
    }
  }
};
